export const CAROUSEL_TIME = 7;
export const CARD_CAROUSEL_CUTOFF = 4;
